<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3b" id="part01ch02"><a id="page_15"></a><strong>F<span class="small">EMUR</span></strong></h3>
<p class="noindent"><a id="page_16"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01ch02.vue?f7ff6fba